export default __webpack_public_path__ + "static/media/ameen_alabasi.555a79d8.m4a";